<template>
  <svg-map :map="France">
    <template v-slot:after>
      <g
        v-for="e in offices"
        :key="e.id"
        :transform="
          'translate(' +
            (getX(14900, e.lon) - 7247) +
            ',' +
            (getY(14900, 4885, e.lat)) +
            ')'
        "
        :label="e.name"
        class="location-pin"
        v-on:click="$emit('update', e)"
        @mouseover="$emit('hovering', e)"
        @mouseleave="$emit('hovering', null)"
      >
        <rect
          x="-3"
          y="-3"
          width="25"
          height="25"
          stroke="black"
          fill="transparent"
          stroke-width="0"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
          />
        </svg>
      </g>
    </template>
  </svg-map>
</template>

<script>
import { SvgMap } from "vue-svg-map";
import France from "@svg-maps/france.regions";

export default {
  name: "Map",
  components: {
    SvgMap,
  },

  props: {
    offices: Array,
  },

  data() {
    return {
      France,
    };
  },

  methods: {
    fmod(a, b) {
      return Number((a - Math.floor(a / b) * b).toPrecision(8));
    },
    getX(width, lon) {
      return Math.round(
        this.fmod((width * (180.0 + lon)) / 360.0, 1.5 * width)
      );
    },
    getY(width, height, lat) {
      const lat_rad = (lat * Math.PI) / 180.0;
      const merc =
        0.5 * Math.log((1 + Math.sin(lat_rad)) / (1 - Math.sin(lat_rad)));
      return Math.round(height / 2 - (width * merc) / (2 * Math.PI));
    },
  },
};
</script>

<style scoped>
svg {
  margin-top: 2%;
  overflow: visible;
}

svg g {
  cursor: pointer;
  stroke-width: 0;
  fill: rgb(46, 46, 46);
}

svg g:hover svg,
svg g:focus svg {
  fill: rgb(228, 228, 228);
}
</style>
